// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"ErrorMessage_errorMessage__3xWfu"};